module.exports = __webpack_public_path__ + "static/media/29170004-min.9ad52bd7.jpg";